<template>
  <div>
    <div class="my-1">
      <b-button
        variant="primary"
        class="mr-1"
        @click="fileInputClick"
      >
        {{$t('objects.select_floor_plans')}}
      </b-button>
      <b-form-file
        ref="filePlanning"
        v-model="new_planning_file"
        plain
        class="d-none"
        :browse-text="$t('objects.select_floor_plans')"
        @input="fileChanged"
      />
    </div>
    <b-card>
      <b-table
        striped
        :fields="fields"
        :items="GET_FLATS_PLANNINGS"
      >
        <template #head()="data">
          <span>{{ $t(data.label) }}</span>
        </template>
        <template #empty>
          <div class="text-center">{{ $t('general.no_records_to_show') }}</div>
        </template>

        <template
          #cell(planning)="props"
        >
          <div style="max-width: 150px">
            <b-img
              class="w-100"
              thumbnail
              :src="props.item.image_2d"
            />
          </div>
        </template>
        <template
          #cell(3d_planning)="props"
        >
          <div
            v-if="props.item.image_3d"
            style="max-width: 150px"
          >
            <b-img
              class="w-100"
              thumbnail
              :src="props.item.image_3d"
            />
          </div>
          <div v-else>
            <b-button
              variant="primary"
              @click="upload3dImage(props.item.id)"
            >
              {{$t('objects.upload')}}
            </b-button>
          </div>
        </template>
        <template #cell(flats)="props">
          <span
            v-for="(flat, index) in props.item.flats"
            :key="index"
          >
            №{{ flat.flat_number }},
          </span>
          <div class="mt-50">
            <b-button
              v-b-modal.shaxmatka
              size="sm"
              variant="primary"
              @click="openShaxmatkaModal(props.item)"
            >
              {{$t('objects.mark_on_grid')}}
            </b-button>
          </div>
        </template>
        <template #cell(actions)="props">
          <div class="h-100 d-flex justify-content-around align-items-center">
            <b-button
              v-b-modal.flat-planning
              variant="warning"
              size="sm"
              @click="openEditModal(props.item)"
            >
              <feather-icon
                icon="EditIcon"
              />
              {{$t('generals.edit')}}
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              @click="deletePlanning(props.item.id)"
            >
              <feather-icon
                icon="TrashIcon"
              />
              {{$t('generals.delete')}}
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>
    <b-modal
      id="flat-planning"
      :title="$t('objects.layout')"
      size="xl"
      :ok-title="$t('generals.save')"
      :cancel-title="$t('generals.cancel')"
      @ok="saveChanges"
    >
      <b-row>
        <b-form-file
          ref="editfilePlanning"
          v-model="edited_planning_file"
          plain
          class="d-none"
          :browse-text="$t('objects.choose_room_layouts')"
          @input="editedfileChange"
        />
        <b-col
          v-if="flat_planning.image_2d"
          class="d-flex flex-column align-items-center"
          cols="6"
        >
          <!-- height="450px" -->
          <b-img
            class="w-100"
            :src="flat_planning.image_2d_preview || flat_planning.image_2d"
          />
          <div class="mt-2 d-flex justify-content-center">
            <b-button
              pill
              variant="warning"
              size="sm"
              class="mr-3"
              @click="editPlanning('2D')"
            >
              <feather-icon
                icon="EditIcon"
              />
              {{$t('generals.update')}}
            </b-button>
            <b-button
              variant="danger"
              pill
              size="sm"
              @click="flat_planning.image_2d = null"
            >
              <feather-icon
                icon="TrashIcon"
              />
              {{$t('generals.delete')}}
            </b-button>
          </div>
        </b-col>
        <b-col
          v-if="flat_planning.image_3d"
          class="d-flex flex-column align-items-center"
          cols="6"
        >
          <!-- height="450px" -->
          <b-img
            class="w-100"
            :src="flat_planning.image_3d_preview || flat_planning.image_3d"
          />
          <div class="mt-2 d-flex justify-content-center">
            <b-button
              pill
              variant="warning"
              size="sm"
              class="mr-3"
              @click="editPlanning('3D')"
            >
              <feather-icon
                icon="EditIcon"
              />
              {{$t('generals.update')}}
            </b-button>
            <b-button
              variant="danger"
              pill
              size="sm"
              @click="flat_planning.image_3d = null"
            >
              <feather-icon
                icon="TrashIcon"
              />
              {{$t('generals.delete')}}
            </b-button>
          </div>
        </b-col>
      </b-row>
      <custom-input
        v-model="flat_planning.planning_code"
        class="mt-2"
        :field-label="$t('objects.generic_number')"
      />
    </b-modal>
    <b-modal
      id="shaxmatka"
      size="xl"
      :title="$t('objects.mash')"
      :ok-title="$t('generals.save')"
      :cancel-title="$t('generals.cancel')"
      @ok="saveAttachments"
    >
      <vue-selecto
        :data="GET_CHECKERBOARD_LAYOUT"
        :initially_selected_elements="initially_selected_flats"
        @selectoEnd="addSelections"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BTable, BFormFile, BImg, BRow, BCol, BCard,
} from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import vueSelecto from '@/components/vueSelecto.vue'
import customInput from '@/components/CustomValidatedInput.vue'
import formatters from '@/mixins/extra'

export default {
  components: {
    BButton,
    BTable,
    BFormFile,
    BImg,
    FeatherIcon,
    vueSelecto,
    BRow,
    BCol,
    BCard,
    customInput,
  },
  mixins: [formatters],
  data() {
    return {
      new_planning_file: null,
      edited_planning_file: null,
      edited_planning_type: null,
      flat_planning: {},
      is_3d_image: false,
      editing_planning_id: null,
      selected_flats: [],
      selected_planning_id: null,
      initially_selected_flats: [],
      fields: [
        {
          key: 'planning',
          label: 'objects.layout',
        },
        {
          key: '3d_planning',
          label: 'objects.3d_planning',
        },
        {
          key: 'planning_code',
          label: 'objects.generic_number',
        },
        {
          key: 'flats',
          label: 'objects.premises_corresponding_layout',
        },
        {
          key: 'actions',
          label: 'objects.actions',
          tdClass: 'width-350',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('apartments', ['GET_FLATS_PLANNINGS_BY_APARTMENT', 'GET_ONE_APARTMENT', 'GET_APARTMENT_MAIN_INFO', 'GET_CHECKERBOARD_LAYOUT']),
    ...mapGetters('flats', ['GET_FLATS_PLANNINGS']),
  },
  mounted() {
    this.refresh()
    this.FETCH_ONE_APARTMENT(this.$route.params.id).then(() => {
      this.updateBreadcrumb()
    })
  },
  methods: {
    ...mapActions('apartments', ['FETCH_FLATS_PLANNINGS_BY_APARTMENT', 'FETCH_ONE_APARTMENT', 'FETCH_APARTMENT_CHECKERBOARD_LAYOUT']),
    ...mapActions('flats', ['CREATE_FLAT_PLANNING', 'DELETE_FLAT_PLANNING', 'FETCH_FLATS_PLANNINGS', 'EDIT_FLAT_PLANNING', 'ATTACH_FLATS_TO_PLANNING']),
    ...mapMutations('breadcrumb', ['UPDATE_BREADCRUMB']),
    fileInputClick() {
      this.$refs.filePlanning.$el.click()
    },
    openShaxmatkaModal(planning) {
      this.selected_planning_id = planning.id
      this.initially_selected_flats = planning.flats.map(el => el.id)
    },
    refresh() {
      this.FETCH_FLATS_PLANNINGS({ apartment: this.$route.params.id, page_size: 100000 })
      this.FETCH_APARTMENT_CHECKERBOARD_LAYOUT(this.$route.params.id)
      this.new_planning_file = null
    },
    updateBreadcrumb() {
      const [first, second, third, fourth] = this.$_removeObjectConnection(this.$route.meta.breadcrumb)
      second.text = this.GET_APARTMENT_MAIN_INFO.rc_object
      second.to = second.to.replace(':id', this.GET_ONE_APARTMENT.rc_object)
      third.text = this.GET_ONE_APARTMENT.title
      third.to = third.to.replace(':id', this.GET_ONE_APARTMENT.id)
      this.UPDATE_BREADCRUMB([first, second, third, fourth])
    },
    fileChanged() {
      if (this.new_planning_file) {
        const fd = new FormData()
        fd.append('apartment', this.$route.params.id)
        if (this.is_3d_image) {
          fd.append('image_3d', this.new_planning_file)
          fd.append('id', this.editing_planning_id)
          this.EDIT_FLAT_PLANNING(fd).then(() => {
            this.is_3d_image = false
            this.$_successToast(this.$t('generals.updated'))
            this.refresh()
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        } else {
          fd.append('image_2d', this.new_planning_file)
          this.CREATE_FLAT_PLANNING(fd).then(() => {
            this.$_successToast(this.$t('generals.added'))
            this.refresh()
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        }
      }
    },
    saveChanges() {
      const {
        id, image_2d, image_3d, planning_code,
      } = this.flat_planning
      const reqData = new FormData()
      reqData.append('id', id)
      reqData.append('planning_code', planning_code)
      if (typeof image_2d !== 'string') reqData.append('image_2d', image_2d)
      if (typeof image_3d !== 'string') reqData.append('image_3d', image_3d)
      this.EDIT_FLAT_PLANNING(reqData).then(() => {
        this.flat_planning = {}
        this.$_successToast(this.$t('generals.updated'))
        this.refresh()
      }).catch(() => {
        this.$_errorToast(this.$t('generals.error'))
      })
    },
    upload3dImage(id) {
      this.is_3d_image = true
      this.editing_planning_id = id
      this.fileInputClick()
    },
    openEditModal(flat_planning) {
      this.flat_planning = this.$_removeObjectConnection(flat_planning)
    },
    editPlanning(type) {
      this.edited_planning_type = type
      this.$refs.editfilePlanning.$el.click()
    },
    async editedfileChange() {
      if (this.edited_planning_type === '2D') {
        this.flat_planning.image_2d_preview = await this.$_convertToBase64(this.edited_planning_file)
        this.flat_planning.image_2d = this.edited_planning_file
      } else if (this.edited_planning_type === '3D') {
        this.flat_planning.image_3d_preview = await this.$_convertToBase64(this.edited_planning_file)
        this.flat_planning.image_3d = this.edited_planning_file
      }
    },
    deletePlanning(id) {
      this.$_showAreYouSureModal().then(value => {
        if (value) {
          this.DELETE_FLAT_PLANNING(id).then(() => {
            this.$_successToast(this.$t('generals.deleted'))
            this.refresh()
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        }
      })
    },
    addSelections(elements) {
      console.log(elements)
      this.selected_flats = elements
    },
    saveAttachments() {
      this.ATTACH_FLATS_TO_PLANNING({ id: this.selected_planning_id, flats: this.selected_flats }).then(() => {
        this.$_successToast(this.$t('generals.attached'))
        this.refresh()
      }).catch(() => {
        this.$_errorToast(this.$t('generals.error'))
      })
    },
  },
}
</script>

<style>

</style>
